import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { PlatformList } from '../../helpers/platformList';
import WhatsPROLogo from '../../assets/logos/WhatsPRO.svg';

// UI kit
import { Card, Button, Alert, AlertDescription } from '@/components/ui';

const FailureSynchronizeView = () => {

    const params = useParams();
    const query = new URLSearchParams(window.location.search);

    const error = query.get('error');

    // const [ shopPlatform ] = useState(PlatformList.find((platform) => platform.name === params.platform).name);
    const [shopPlatform, setShopPlatform] = useState(null);

    useEffect(() => {
        const platform = PlatformList.find((platform) => platform.name === params.platform);
        if (platform) {
            setShopPlatform(platform);
        } else {
        }
    }, [params.platform]);
    return (
        <div className="flex min-h-screen w-full items-center justify-center bg-background px-4">
            <Card className="w-full max-w-md overflow-hidden p-0 text-center">
                {/* deck accent bar — thin brand gradient, used sparingly */}
                <div className="h-1 w-full bg-grad" />
                <div className="flex flex-col items-center gap-5 px-8 py-12">
                    <div className="flex h-14 w-14 items-center justify-center rounded-full bg-danger-tint text-danger">
                        <AlertTriangle className="h-7 w-7" />
                    </div>
                    <img src={WhatsPROLogo} alt="WhatsPRO" className="h-7 w-auto" />
                    <h1 className="text-xl font-bold tracking-[-0.01em] text-foreground text-balance">
                        No pudimos sincronizar tu tienda
                    </h1>
                    <Alert variant="danger" className="text-left">
                        <AlertDescription>
                            {error ?? 'Ocurrió un error inesperado. Por favor, intentalo de nuevo'}
                        </AlertDescription>
                    </Alert>
                    <Button
                        key={shopPlatform?.name ?? 1}
                        className="w-full"
                        onClick={() => {
                            window.location.href = shopPlatform?.redirectHref ?? window.location.origin + '/welcome';
                        }}
                    >
                        Reintentar
                    </Button>
                </div>
            </Card>
        </div>
    );
};

export { FailureSynchronizeView };
